export const WINDOW_FOCUS_REQUEST = 'WINDOW_FOCUS_REQUEST';
export const WINDOW_FOCUS_SUCCESS = 'WINDOW_FOCUS_SUCCESS'; 
export const WINDOW_FOCUS_ERROR = 'WINDOW_FOCUS_ERROR'; 
